import React from 'react';
import {
  TwtPackageFloorplanAddOns,
  TwtPackageFloorplanInclude,
  TwtPackagePhotoAddOns,
  TwtPackagePhotoInclude,
  TwtPackageTimeOfDay,
} from '~/tenants/twt/package/common';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { PersonaType } from '~/tenants/common/TenantPersona';

import { TwtOrderType } from '~/tenants/twt/model/enums';
import TwtDetached from '~/tenants/twt/forms/TwtDetached';
import TwtMatterportConfig from '~/tenants/twt/performable/matterport/TwtMatterportConfig';
import PerformableGroupForm, { PerformableGroupNested } from '~/components/performable/PerformableGroupForm';
import TwtFloorplanConfig from '~/tenants/twt/performable/floorplan/TwtFloorplanConfig';
import { ZodNestedForm } from '~/components/zod/ZodForm';

export default function TwtFloorplanTourForm() {
  return (
    <>
      <TenantPackageIncludes>
        <TwtPackagePhotoInclude />
        <TwtPackageFloorplanInclude />
      </TenantPackageIncludes>
      <div className="pt-6">
        <PerformableGroupNested performable={TwtFloorplanConfig}>
          <ZodNestedForm name="metadata">
            <TwtDetached />
          </ZodNestedForm>
        </PerformableGroupNested>
      </div>
      <TwtPackageTimeOfDay />
      <TenantPerformableAddOns persona={PersonaType.CUSTOMER}>
        <TwtPackagePhotoAddOns type={TwtOrderType.FOR_SALE_LISTING} />
        <TwtPackageFloorplanAddOns />
      </TenantPerformableAddOns>
    </>
  );
}
